import styled from "styled-components";
import { Box, Button, Typography } from "@mui/material";

interface ResponsiveProps {
  $isPhone?: boolean;
  $lang?: string;
  $BgColor?: string;
  $TextColor?: string;
  $width?: string;
}

export const ModalWrapper = styled.span<ResponsiveProps>`
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  position: absolute;
  width: ${({ $isPhone }) => ($isPhone ? "90vw" : "867px")};
  outline: none;
  border-top-left-radius: ${({ $isPhone }) => ($isPhone ? "12px" : "16px")};
  border-bottom-left-radius: ${({ $isPhone }) => ($isPhone ? "12px" : "16px")};
  background: #ffffff;
  height: fit-content;
  max-height: ${({ $isPhone }) => ($isPhone ? "90vh" : "auto")};
  overflow-y: ${({ $isPhone }) => ($isPhone ? "auto" : "visible")};
`;

export const CloseButtonWrapper = styled.span<ResponsiveProps>`
  width: 100%;
  display: flex;
  justify-content: end;
  align-items: end;
  padding: ${({ $isPhone }) => ($isPhone ? "16px" : "0")};
`;

export const CloseMenuIcon = styled.div<ResponsiveProps>`
  width: ${({ $isPhone }) => ($isPhone ? "16px" : "14px")};
  height: ${({ $isPhone }) => ($isPhone ? "16px" : "14px")};
  fill: black;
  margin: ${({ $isPhone }) => ($isPhone ? "8px" : "25px")};
  cursor: pointer;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 0.7;
  }
`;

export const CardContainer = styled.div<ResponsiveProps>``;

export const ImageWrapper = styled.div<ResponsiveProps>`
  margin-top: ${({ $isPhone }) => ($isPhone ? "24px" : "42px")};
  display: flex;
  justify-content: center;
  background: #fafafb;
  padding-top: 50px;
  width: ${({ $isPhone }) => ($isPhone ? "100%" : "565.18px")};
  height: ${({ $isPhone }) => ($isPhone ? "auto" : "300px")};
  border-radius: 14.29px;
  margin-right: ${({ $isPhone }) => ($isPhone ? "0" : "150px")};
`;

export const ContentBox = styled.span<ResponsiveProps>`
  display: flex;
  flex-direction: column;
  align-items: ${({ $isPhone }) => ($isPhone ? "center" : "start")};
  padding-inline: ${({ $isPhone }) => ($isPhone ? "16px" : "117px")};
  gap: 0;
  background: white;
  position: relative;
  text-align: ${({ $isPhone }) => ($isPhone ? "center" : "start")};
`;

export const Title = styled.span<ResponsiveProps>`
  font-weight: 400;
  font-size: ${({ $isPhone }) => ($isPhone ? "18px" : "20px")};
  color: #0f172a;
`;

export const Description = styled.span<ResponsiveProps>`
  font-weight: 400;
  font-size: ${({ $isPhone }) => ($isPhone ? "14px" : "16px")};
  color: #8e98a1;
`;

export const SliderContainer = styled.span<ResponsiveProps>`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: ${({ $isPhone }) => ($isPhone ? "24px" : "34px")};
  padding-inline: ${({ $isPhone }) => ($isPhone ? "16px" : "0")};
`;

export const ActionContainer = styled.div<ResponsiveProps>`
  background: #ffffff;
  display: flex;
  align-items: center;
  width: 100%;
  gap: ${({ $isPhone }) => ($isPhone ? "8px" : "10px")};
  justify-content: ${({ $isPhone }) => ($isPhone ? "center" : "end")};
  height: ${({ $isPhone }) => ($isPhone ? "80px" : "97px")};
  border-bottom-left-radius: ${({ $isPhone }) => ($isPhone ? "12px" : "24px")};
  border-bottom-right-radius: ${({ $isPhone }) => ($isPhone ? "12px" : "24px")};
  padding: ${({ $isPhone }) => ($isPhone ? "16px" : "24px")};
  padding-inline: ${({ $isPhone }) => ($isPhone ? "16px" : "24px")};
  border-top: 1px solid #0000001a;
  flex-direction: ${({ $isPhone }) => ($isPhone ? "column" : "row")};
`;

export const StyledButton = styled.button<ResponsiveProps>`
  width: ${({ $width, $isPhone }) => ($isPhone ? "100%" : $width)};
  height: ${({ $isPhone }) => ($isPhone ? "44px" : "49px")};
  border-radius: 69px;
  font-size: ${({ $isPhone }) => ($isPhone ? "14px" : "16px")};
  color: ${({ $TextColor }) => $TextColor};
  background-color: ${({ $BgColor }) => $BgColor};
  border: 1px solid #5b3fff;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.2s ease;

  /* 🛑 Remove hover effect */
  &:hover {
    background-color: ${({ $BgColor }) => $BgColor};
    color: ${({ $TextColor }) => $TextColor};
  }

  @media (max-width: 480px) {
    width: 100%;
    margin-bottom: ${({ $isPhone }) => ($isPhone ? "8px" : "0")};
  }
`;
